import React, { useEffect, useState } from "react";
import { ReactComponent as Verify } from "../../../../assets/icons/verify.svg";
import SearchlistIcon from "../../../../assets/icons/searchlisticon.png";
import { ReactComponent as Manufacture } from "../../../../assets/images/manufacture.svg";
import { ReactComponent as ArrowRightYellow } from "../../../../assets/images/ArrowRightYellow.svg";
import { Countries } from "../../../public/Home/CountryFlag";
import { Modal } from "../../../common";
import FollowPopup from "../following/FollowPopup";
import { Link } from "react-router-dom";
import { getCountryByCode, isVerified } from "../../../../utils/Helper";
import { useGetCompanyQuery } from "../../../../store/Company/companyApiSlice";
import { useGetCompanyNewQuery } from "../../../../store/search/searchApiSlice";
import { ReactComponent as Rocket } from "../../../../assets/images/rocket.svg";
import { toSentenceCaseCP } from "../../../../global_functions/global";

export const PurchasedCompanyCard = ({ company, token, status, companyData, is_expired, expired_date}) => {
  const [flag, setFlag] = useState({});
  const [notification, setNotification] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [checkTrevexCompany, setCheckTrevexCompany] = useState(false);
  // this component is written inside map, so it calling the API call multiple time in this page, need to fix all the API call.
  const { data } = useGetCompanyQuery(
    {
      token: token,
      companyId: company,
    },
    { enabled: !!checkTrevexCompany }
  );
  const { data: worldBoxCompany } = useGetCompanyNewQuery({
    id: company,
  });

  useEffect(() => {
    if (company?.startsWith("TRX")) {
      setCheckTrevexCompany(true);
    } else {
      setCheckTrevexCompany(false);
    }
  }, [company]);

  const modalHandle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    let country_code = checkTrevexCompany
      ? data?.country_code
      : (companyData?.country_code);
    const filteredData = Countries.filter((item) => item.code === country_code);
    setFlag(filteredData[0]?.file_url);
  }, [checkTrevexCompany, data, worldBoxCompany]);
  return (
    <div>
      {isOpen && (
        <Modal modalHandle={modalHandle}>
          <FollowPopup close={modalHandle} />
        </Modal>
      )}
      <div className="bg-white  border  mt-5 border-gray-200 rounded-lg">
        <div className="p-4 sm:p-5">
          <div className="grid md:grid-cols-5 sm:grid-cols-4 grid-cols-1 gap-2  text-left">
            <div className="lg:col-span-4 md:col-span-3 sm:col-span-2 lg:border-r sm:border-r-1 col-span-1">
              <div className="company flex justify-start gap-4">
                <div className="imageicon flex justify-center items-center">
                  <img
                    src={data?.logo || SearchlistIcon}
                    style={{ width: '96px', height: '96px' }}
                    className="w-full rounded-lg"
                    alt={(data?.name || data?.registered_company_name || companyData?.company_ame) ?? ""}
                  />
                </div>
                <div className="mapdetails w-[80%] flex flex-col items-start justify-around">
                  {
                    <h3 className="sm:text-para3 text-f18 text-secondarytwo font-bold">
                      {(checkTrevexCompany
                        ? data?.registered_company_name
                        : worldBoxCompany?.company?.name || companyData?.company_name) ?? ""}
                    </h3>
                  }
                  {data?.industry?.sector && (
                    <p className="text-primaryText hidden bg-greyFade font-semibold text-f12 mt-5 w-full sm:flex items-center px-3 capitalize  py-1 rounded-2xl gap-3 tracking-subheading truncate">
                      <Rocket className="sm:w-auto w-16" /> {toSentenceCaseCP(data?.industry?.sector)}{" "}
                      {"  "}|{"  "} {toSentenceCaseCP(data?.industry?.sub_industry)}
                    </p>
                  )}
                  <div className="flex items-center pt-2 sm:pt-0 gap-2 mt-2">
                    <div className="flex text-secondary p-1 rounded-full">
                      <span className="sm:text-f12 block text-secondarytwo text-f12 tracking-subheading font-normal flex items-center">
                        {flag && (
                          <img
                            src={`${flag}`}
                            width="20px"
                            height="auto"
                            className="mr-2 h-6"
                            alt="hello"
                          />
                        )}
                        <p className="capitalize">
                          {company?.startsWith("TRX") ?
                            data?.companyAddress[0]?.company_address_detailsID
                              ?.state &&
                            `${data?.companyAddress[0]?.company_address_detailsID?.state}, ` : worldBoxCompany?.company?.city != '' && `${(worldBoxCompany?.company?.city?.toLowerCase() || (companyData?.city && companyData?.city))}, `}
                          {getCountryByCode(
                            (checkTrevexCompany
                              ? data?.country_code
                              : (worldBoxCompany?.company?.countrycode || companyData?.country_code))
                          ) ?? ""}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="view_profile lg:col-span-1 sm:col-span-2 col-span-1 flex sm:pt-0 pt-2 sm:flex-col items-end justify-around">
              {false && (
                <div className="flex items-center justify-end p-1 px-3 bg-success rounded-full w-fit tracking-heading">
                  <Verify />
                  <span className="text-success font-bold px-1 text-f16">
                    VERIFIED
                  </span>
                </div>
              )}
              {
                status == 'no_worldbox' ?
                  <Link
                    to={`/search/${checkTrevexCompany
                      ? data?.companyID
                      : worldBoxCompany?.company?.win
                      }`}
                    target="_blank"
                    className="flex items-center gap-2 mx-auto mr-0 text-link border group border-link rounded bg-white font-sans sm:text-f12 px-6 py-2 font-bold "
                  >
                    <span>View more</span>
                    <svg
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.5 11L11.5 1M11.5 1H4M11.5 1V8.5"
                        stroke="#002940"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Link> :
                  <div className="max-w-max flex space-x-2.5 py-0.5 px-2.5 rounded-full items-center justify-center mx-auto"
                    style={{ backgroundColor: '#ff6a00' }}>
                    <span style={{ color: '#fff', fontSize: 12 }}>Report in progress</span>
                  </div>
              }
            </div>
          </div>
        </div>
        {notification && (
          <div className="w-full bg-company p-2 sm:px-5 rounded-b-lg text-f14 flex items-center justify-between">
            <div className=" tracking-subheading text-left text-slate  sm:w-3/4">
              3 new updates in this business profile.
            </div>
            <div
              className="text-updates font-semibold flex sm:w-1/4 gap-2 justify-end cursor-pointer"
              onClick={modalHandle}
            >
              View Updates <ArrowRightYellow />
            </div>
          </div>
        )}
        {is_expired && (
          <div className="w-full bg-company p-2 sm:px-5 rounded-b-lg text-f14 flex items-center justify-between">
            <div className=" tracking-subheading text-left text-slate  sm:w-3/4">
              Your purchase expired on {expired_date}
            </div>

          </div>
        )}
      </div>
    </div>
  );
};
